export default "__VITE_ASSET__Dbv3pXVS__"